import React from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, Legend } from "recharts";

function LineGraph({ data, xLabelKey, yLabelKey, legends = [], width, height, className = "", animation = true }) {
	return (
		<LineChart className={className} width={width} height={height} data={data} margin={{ top: 16, right: 12, left: 4, bottom: 8 }}>
			<XAxis dataKey={xLabelKey} tick={{ fontSize: 11 }} minTickGap={14} tickLine={false} axisLine={{ stroke: "#9ca3af" }} />
			<YAxis dataKey={yLabelKey} tick={{ fontSize: 11 }} tickFormatter={(v) => `${v}`} tickLine={false} axisLine={{ stroke: "#9ca3af" }} />
			<Tooltip contentStyle={{ borderRadius: 8, borderColor: "#e5e7eb" }} />
			<Legend />
			{legends.map((line, i) => {
				return <Line key={i} type="monotone" dataKey={line.title} stroke={line.color} activeDot={{ r: 5 }} strokeWidth={2.5} dot={{ r: 3 }} isAnimationActive={animation} />;
			})}
		</LineChart>
	);
}

export default LineGraph;
